export const buttonVariants = {
  primary:
    'bg-gradient-to-r from-primary-600 to-accent-600 text-white hover:from-primary-700 hover:to-accent-700 shadow-lg hover:shadow-xl',
  secondary:
    'bg-white text-primary-700 border-2 border-primary-600 hover:bg-primary-50',
  ghost: 'text-gray-700 hover:bg-gray-100',
  danger: 'bg-red-600 text-white hover:bg-red-700',
  link: 'text-primary-600 underline-offset-4 hover:underline p-0 h-auto',
};

export const buttonSizes = {
  sm: 'h-9 px-3 text-sm rounded-lg',
  md: 'h-11 px-5 text-sm rounded-xl',
  lg: 'h-12 px-6 text-base rounded-xl',
  icon: 'h-10 w-10 p-0 rounded-lg',
};

export const inputSizes = {
  sm: 'h-9 text-sm px-3',
  md: 'h-11 text-sm px-4',
  lg: 'h-12 text-base px-4',
};

export const alertVariants = {
  info: 'bg-primary-50 border-primary-200 text-primary-900',
  success: 'bg-green-50 border-green-200 text-green-900',
  warning: 'bg-amber-50 border-amber-200 text-amber-900',
  error: 'bg-red-50 border-red-200 text-red-900',
};
